<template>
  <div
    id="app"
    :style="{
      fontFamily:
        $i18n.locale === 'zh-CN'
          ? 'Avenir, Helvetica, Arial, sans-serif'
          : 'English,Avenir, Helvetica, Arial, sans-serif',
    }"
  >
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Layout",
  created() {
    const language = sessionStorage.getItem("language") || "zh-CN";
    console.log(19, language);
    if (language === "zh-CN") {
      this.$i18n.locale = "zh-CN"; //关键语句
      sessionStorage.setItem("language", "zh-CN");
    } else {
      this.$i18n.locale = "en-US"; //关键语句
      sessionStorage.setItem("language", "en-US");
    }
  },
};
</script>
<style lang="scss">
body {
  position: relative;
  margin: 0;
}

@media (max-width: 980px) {
  html {
    font-size: 16px;
    -webkit-text-size-adjust: none;
  }
}
#app {
  font-family: "English", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #000;
}
#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
